"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var jsx_runtime_1 = require("react/jsx-runtime");
var App_1 = require("App");
var classnames_1 = __importDefault(require("classnames"));
var nanoid_1 = require("nanoid");
var react_2 = require("react");
var react_hook_form_1 = require("react-hook-form");
var react_modal_1 = __importDefault(require("react-modal"));
var add_svg_1 = __importDefault(require("../icons/add.svg"));
var close_svg_1 = __importDefault(require("../icons/close.svg"));
var remove_svg_1 = __importDefault(require("../icons/remove.svg"));
var utils_1 = require("../utils");
var FieldErrorMessage_1 = __importDefault(require("./FieldErrorMessage"));
var Input_1 = __importDefault(require("./Input"));
var Select_1 = __importDefault(require("./Select"));
var FormModal = (0, react_2.forwardRef)(function (props) {
    var _a;
    var context = (0, react_2.useContext)(App_1.CareersContext);
    var title = (0, utils_1.getLabel)(props.title, props.title, (_a = context === null || context === void 0 ? void 0 : context.options) === null || _a === void 0 ? void 0 : _a.labels);
    var formMethods = (0, react_hook_form_1.useForm)({ reValidateMode: "onChange" });
    var control = formMethods.control, handleSubmit = formMethods.handleSubmit;
    var _b = (0, react_hook_form_1.useFieldArray)({
        control: control,
        name: props.title,
    }), fields = _b.fields, append = _b.append, prepend = _b.prepend, remove = _b.remove;
    (0, react_2.useEffect)(function () {
        if (fields.length === 0 && props.isModalOpen) {
            append({
                id: (0, nanoid_1.nanoid)(),
            });
        }
    }, [props.isModalOpen]);
    (0, react_2.useEffect)(function () {
        if (props.isModalOpen) {
            document.body.style.overflow = "hidden";
        }
        return function () {
            document.body.style.overflow = "unset";
        };
    }, [props.isModalOpen]);
    var onClick = function (data) {
        props.onChange(data[props.title]);
        props.setIsModalOpen(false);
    };
    var dismissModal = function () {
        props.setIsModalOpen(false);
    };
    return ((0, jsx_runtime_1.jsxs)(react_modal_1.default, { appElement: document.getElementById("root"), isOpen: props.isModalOpen, onRequestClose: function () { }, className: (0, classnames_1.default)("z-50 ReactModal__Overlay bg-white rounded-lg outline-none w-full h-full p-0 overflow-y-scroll", props.isModalOpen
            ? "ReactModal__Overlay--after-open"
            : "ReactModal__Overlay--before-close"), overlayClassName: "fixed inset-0 z-50", closeTimeoutMS: 500, preventScroll: true, children: [(0, jsx_runtime_1.jsx)("div", { className: "shadow-sm h-24 flex items-center justify-center p-fi-spacing", children: (0, jsx_runtime_1.jsx)("div", { className: "!container", children: (0, jsx_runtime_1.jsxs)("div", { className: "flex justify-between p-fi-tr items-center", children: [(0, jsx_runtime_1.jsx)("p", { className: "m-0", children: title }), (0, jsx_runtime_1.jsx)("div", { className: "cursor-pointer ", onClick: dismissModal, children: (0, jsx_runtime_1.jsx)(close_svg_1.default, { className: "text-fi-primary hover:text-fi-primary-hover w-4 h-4" }) })] }) }) }), (0, jsx_runtime_1.jsxs)("div", { className: "mt-1 p-fi-spacing bg-fi-bg-secondary min-h-full overflow-y-scroll", children: [(0, jsx_runtime_1.jsxs)("div", { className: "!container flex items-center justify-center gap-spacing", children: [(0, jsx_runtime_1.jsx)("button", { type: "submit", className: "bg-fi-primary hover:bg-fi-primary-hover text-fi-secondary-font p-fi rounded-fi", onClick: handleSubmit(onClick), children: (0, utils_1.t)("add") }), (0, jsx_runtime_1.jsx)("button", { type: "button", className: "bg-fi-danger hover:bg-fi-danger-hover text-fi-secondary-font p-fi rounded-fi", onClick: dismissModal, children: (0, utils_1.t)("cancel") })] }), (0, jsx_runtime_1.jsxs)("div", { className: "!container", children: [(0, jsx_runtime_1.jsxs)("div", { className: "-mb-spacing flex gap-2 cursor-pointer  items-center", onClick: function (e) {
                                    e.preventDefault();
                                    prepend({
                                        id: (0, nanoid_1.nanoid)(),
                                    });
                                }, children: [(0, jsx_runtime_1.jsx)(add_svg_1.default, { className: "text-fi-secondary hover:text-fi-secondary-hover w-4 h-4" }), (0, jsx_runtime_1.jsxs)("span", { className: "text-fi-secondary hover:text-fi-secondary-hover", children: [(0, utils_1.t)("add a new"), " ", title] })] }), fields.map(function (_, fieldIndex) { return ((0, jsx_runtime_1.jsxs)("div", { className: "mt-spacing bg-fi-white p-4 rounded-fi", children: [(0, jsx_runtime_1.jsx)("div", { className: "flex justify-end", onClick: function () {
                                            remove(fieldIndex);
                                        }, children: (0, jsx_runtime_1.jsx)(remove_svg_1.default, { className: "text-fi-danger hover:text-fi-danger-hover cursor-pointer w-4 h-4" }) }), (0, jsx_runtime_1.jsx)("div", { className: "grid gap-spacing", children: Object.keys(props.section).map(function (key, index) {
                                            if (!props.requiredFields)
                                                return null;
                                            return ((0, react_1.createElement)(react_hook_form_1.FormProvider, __assign({}, formMethods, { key: index }), (0, jsx_runtime_1.jsx)(SectionInput, __assign({ fieldIndex: fieldIndex }, props, { requiredFields: props.requiredFields, fieldKey: key }))));
                                        }) })] }, _.id)); })] })] })] }));
});
var SectionInput = function (props) {
    var _a, _b, _c;
    var _d = (0, react_hook_form_1.useFormContext)(), control = _d.control, register = _d.register, errors = _d.formState.errors;
    var fieldName = "".concat(props.title, "[").concat(props.fieldIndex, "].").concat(props.fieldKey);
    var section = (_a = props.section) === null || _a === void 0 ? void 0 : _a[props.fieldKey];
    var sectionRequiredFields = (_b = props.requiredFields) === null || _b === void 0 ? void 0 : _b[props.title];
    var fieldErrors = errors === null || errors === void 0 ? void 0 : errors[props.title];
    var context = (0, react_2.useContext)(App_1.CareersContext);
    function validateSelectInput(_a) {
        var type = _a.type, value = _a.value;
        if (value === "" || value === undefined) {
            return (0, utils_1.t)("Please select an option");
        }
        return true;
    }
    if (section.rule === "date_range") {
        return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("h5", { className: "font-normal", children: [section.label, " ", (0, utils_1.isRequired)(props.fieldKey, sectionRequiredFields).value && "*"] }), (0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { name: fieldName, control: control, rules: {
                        required: (0, utils_1.isRequired)(props.fieldKey, sectionRequiredFields),
                        validate: function (date) {
                            if (date && typeof date == "object") {
                                if (!date.from || !date.to) {
                                    return (0, utils_1.t)("this field is required");
                                }
                                if (date.from > date.to || date.from == date.to) {
                                    return (0, utils_1.t)("Date range is invalid");
                                }
                            }
                        },
                    }, render: function (_a) {
                        var _b = _a.field, onChange = _b.onChange, value = _b.value, rest = __rest(_b, ["onChange", "value"]);
                        var handleChange = function (e) {
                            var _a;
                            onChange(__assign(__assign({}, value), (_a = {}, _a[e.target.name] = e.target.value, _a)));
                        };
                        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Input_1.default, { fieldRequired: false, name: "from", label: (0, utils_1.t)("startedAt"), type: "date", onChange: handleChange, variant: "lg" }), (0, jsx_runtime_1.jsx)(Input_1.default, { fieldRequired: false, name: "to", label: (0, utils_1.t)("endedAt"), type: "date", onChange: handleChange, variant: "lg" })] }));
                    } }), (0, jsx_runtime_1.jsx)(FieldErrorMessage_1.default, { errors: (0, utils_1.getFieldArrayErrors)(props.fieldIndex, fieldErrors), name: props.fieldKey })] }));
    }
    if (section.rule === "country") {
        return ((0, jsx_runtime_1.jsx)(Select_1.default, __assign({}, register(fieldName, {
            required: (0, utils_1.isRequired)(props.fieldKey, sectionRequiredFields),
            validate: function (value) {
                return validateSelectInput({
                    type: "select",
                    value: value,
                });
            },
        }), { fieldRequired: (0, utils_1.isRequired)(props.fieldKey, sectionRequiredFields).value, label: section.label, errors: errors, values: (_c = context === null || context === void 0 ? void 0 : context.options) === null || _c === void 0 ? void 0 : _c.countries, name: fieldName })));
    }
    if (typeof section.rule === "object") {
        return ((0, jsx_runtime_1.jsx)(Select_1.default, __assign({}, register(fieldName, {
            required: (0, utils_1.isRequired)(props.fieldKey, sectionRequiredFields),
            validate: function (value) {
                return validateSelectInput({
                    type: "select",
                    value: value,
                });
            },
        }), { fieldRequired: (0, utils_1.isRequired)(props.fieldKey, sectionRequiredFields).value, label: section.label, errors: (0, utils_1.getFieldArrayErrors)(props.fieldIndex, fieldErrors), name: fieldName, values: section.rule })));
    }
    if (section.rule === "number") {
        return ((0, jsx_runtime_1.jsx)(Input_1.default, __assign({}, register(fieldName, {
            validate: function (value) {
                if (!value &&
                    !(0, utils_1.isRequired)(props.fieldKey, sectionRequiredFields).value)
                    return true;
                return value > 0 || (0, utils_1.t)("value must be larger than zero");
            },
        }), { fieldRequired: (0, utils_1.isRequired)(props.fieldKey, sectionRequiredFields).value, label: section.label, errors: fieldErrors && (0, utils_1.getFieldArrayErrors)(props.fieldIndex, fieldErrors), name: fieldName, type: "number" })));
    }
    return ((0, jsx_runtime_1.jsx)(Input_1.default, __assign({}, register(fieldName, {
        required: (0, utils_1.isRequired)(props.fieldKey, sectionRequiredFields),
    }), { fieldRequired: (0, utils_1.isRequired)(props.fieldKey, sectionRequiredFields).value, label: section.label, errors: fieldErrors && (0, utils_1.getFieldArrayErrors)(props.fieldIndex, fieldErrors), name: fieldName, type: "text" })));
};
exports.default = FormModal;
